<template>

    <div :class="{'sr-only': config.showExternalFilters==false}">

        <fieldset 
            v-for="(sourceSet, prop) in config.externalSources" 
            :key="prop"
            class="ecm-filters">

            <legend> {{ $t(prop) }} </legend>

            <ul class="ecm-filters-list">
                
                <li
                v-for="(source) in sourceSet.sources"
                :key="source.id"
                class="ecm-form-group-cb">
                    <label v-bind:for="source.id">
                        <svg-injector 
                            v-if="source.icon" 
                            :src="source.icon"
                            class="ecm-category-icon">
                        </svg-injector>
                        {{ getLabel(source.labels) }}
                    </label>
                    <input
                        v-model="checkedExternals"
                        :id="source.id"
                        :value="source.id"
                        type="checkbox"
                        class="ecm-checkbox" />
                </li>

            </ul>

        </fieldset>

    </div>

</template>

<script>
import { eventBus } from '../main.js';

export default {
    name: 'FiltersExternals',
    computed: {
        lan() {
            return this.$store.state.lan;
        },
        config() {
            return this.$store.state.config;
        },
        checkedExternals: {
            set(val) {
                this.$store.commit('setCheckedExternals', val);
                // Trigger load for external set if checked and not loaded already
                this.$store.state.checkedExternals.forEach((name) => {
                    if (! Object.prototype.hasOwnProperty.call(this.$store.state.externalMarkers, name)) {
                        eventBus.$emit('externalFilterChange', name);
                    }
                });
            },
            get() { 
                return this.$store.state.checkedExternals;
            }
        }
    },
    /*watch: {
        checkedExternals() {
            console.log('checkedExternals changed');
        }
    },*/
    data() {
        return {
            
        }
    },
    created() {
        // Refresh initCheckedExternals on map config change
        if (window.emitter) {
            window.emitter.on('setMapConfig', () => {
                this.setInitCheckedExternals();
            });
        }
    },
    mounted() {
        this.setInitCheckedExternals();
    },
    methods: {
        /**
         * Get source label for current lan.
         * @param   {object}    labels
         */
        getLabel(labels) {
            if (!labels) {
                // No labels, return empty string
                return '';
            } else if (labels[this.lan]) {
                // Label for current lan found, return it
                return labels[this.lan];
            } else if (labels['en']) {
                // No label for current lan, return en if set
                return labels['en'];
            } if (labels[0]) {
                // No label for current lan or en, return first label if set
                return labels[0];
            }
            // Labels is defined but it's empty, return empty string
            return '';
        },
        /**
         * Set checked external sources to checkedExternals on init.
         */
        setInitCheckedExternals() {
            this.$store.commit('setCheckedExternals', []);
            for (let sourceSet in this.config.externalSources) {
                let sources = this.config.externalSources[sourceSet].sources;
                for (let i in sources) {
                    if (sources[i].checked) {
                        // Put initially checked external sources to checkedExternals
                        this.$store.commit('addCheckedExternal', sources[i].id);
                    }
                }
            }
        }
    }
}

</script>

<style scoped>

</style>
